import React from 'react'
import 'styles/d3/radio.scss'

const Radio = ({ disabled, selected, content, className, onClick }) => {
  const _onClick = () => {
    if (!selected && !disabled) onClick()
  }
  let _className = 'd3-radio'
  _className = _className += className ? ` ${className}` : ''
  _className = _className += disabled ? ' disabled' : ''
  return (
    <div onClick={_onClick} className={_className}>
      <div className={'radio-circle' + (selected ? ' selected' : '')} />
      <div>{content}</div>
    </div>
  )
}

export default Radio



// WEBPACK FOOTER //
// ./src/components/Radio.js